var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favoriteToggle",on:{"click":_vm.toggle}},[_c('i',{class:{'fas': _vm.isActive, 'far': !_vm.isActive, 'fa-star':true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }